import { Component, Inject, OnInit } from "@angular/core";

import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

import {
    LoadGeoLibrariesServiceModule,
    isGoogleEngine,
    LoadGeoLibrariesService,
} from "@hermes/map-utils";

import { AbstractMapComponent } from "../abstract-base-map.component";
import { MapBaiduDisplayComponent } from "../baidu/map-baidu-display/map-baidu-display.component";
import { MapGoogleDisplayComponent } from "../google/map-google-display/map-google-display.component";

@Component({
    selector: "h-map-container",
    templateUrl: "./map-container.component.html",
    imports: [
        MapBaiduDisplayComponent,
        MapGoogleDisplayComponent,
        LoadGeoLibrariesServiceModule,
    ],
})
export class MapContainerComponent
    extends AbstractMapComponent
    implements OnInit
{
    public isGoogleEngine = isGoogleEngine(this.locale.countryCode);

    constructor(
        @Inject(LOCALE) public locale: Locale,
        private loadGeoLibrariesService: LoadGeoLibrariesService,
    ) {
        super();
    }

    public ngOnInit(): void {
        this.loadGeoLibrariesService.autoLoad();
    }
}
